// Dashboards (POST /dashboard?rel=), os mesmos do app tifiregerencial (constants/dashboards.ts).
// Para criar um novo: o rel na API (uDashApi.GeraDashboard), as linhas de laytel com
// tab='Rel<rel>' e uma entrada aqui.
export interface IConfigDashboard {
  id: string;
  titulo: string;
  /** laytel.tab dos filtros (os mesmos do relatório) */
  layout: string;
  /** Parâmetro `rel` do POST /dashboard */
  rel: string;
  /** laytel.cam das datas inicial e final */
  periodo: { ini: string; fim: string };
  /** Filtros do relatório que não fazem sentido no dashboard */
  ocultar?: string[];
  /** ms; o FluCai monta o fluxo dia a dia e pode demorar */
  timeout?: number;
  /** ids dos widgets exibidos; sem a lista, aparecem todos */
  widgets?: string[];
}

export const DASHBOARDS: IConfigDashboard[] = [
  {
    id: 'pedsai',
    titulo: 'Vendas',
    layout: 'RelPedSai',
    rel: 'PedSai',
    periodo: { ini: 'datini', fim: 'datfin' },
    // só mudam a lista do relatório (ordem e colunas), não os totais
    ocultar: ['ord', 'tip', 'forpag', 'valdesadi'],
    timeout: 60000
  },
  {
    id: 'cheven',
    titulo: 'Cheques das Vendas',
    layout: 'RelCheVen',
    rel: 'CheVen',
    periodo: { ini: 'datini', fim: 'datfin' },
    ocultar: ['relres', 'listotvencat']
  },
  {
    id: 'flucai',
    titulo: 'Fluxo de Caixa',
    layout: 'RelFluCai',
    rel: 'FluCai',
    periodo: { ini: 'datvenini', fim: 'datvenfin' },
    timeout: 120000
  }
];

/** Dashboards da tela de Início, nesta ordem (o CheVen continua registrado, mas fora da Início) */
const IDS_INICIO = ['pedsai', 'flucai'];

export const DASHBOARDS_INICIO = IDS_INICIO
  .map(id => DASHBOARDS.find(dash => dash.id === id))
  .filter((dash): dash is IConfigDashboard => !!dash);
